import { JSONSchemaType } from 'ajv'

export interface ICountryFormData {
  name: string
}

const CountrySchema: JSONSchemaType<ICountryFormData> = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
  },
  required: ['name'],
  additionalProperties: false,
}

export default CountrySchema
